import { createContext } from 'react';
export var ButtonGroupContext = /*#__PURE__*/createContext({});